import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import Detail from '@/views/Detail.vue'
import ProductCenter from '@/views/ProductCenter.vue'
import { startRouteProgress, finishRouteProgress } from '@/utils/routeProgress'

Vue.use(Router)

const router = new Router({
  // 使用 hash 模式，满足你要求的 `#/detail/:id`
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const wrap = document.querySelector('.page-component__scroll .el-scrollbar__wrap')
        /** 带 ?cat= 进产品中心时由页面内锚点滚动，不要先滚到顶部 */
        const skipScrollTop =
          to.name === 'productCenter' &&
          to.query &&
          String(to.query.cat || '') !== ''
        if (wrap && !skipScrollTop) {
          wrap.scrollTop = 0
        }
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 0)
    })
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/product-center',
      name: 'productCenter',
      component: ProductCenter,
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: Detail,
    },
  ],
})

router.beforeEach((to, from, next) => {
  startRouteProgress()
  next()
})

router.afterEach(() => {
  finishRouteProgress()
})

router.onError(() => {
  finishRouteProgress()
})

export default router

